import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { fileRepositoryClient } from '#pplx_generated/typespec/rest/file_repository/client.js';
export const getRepositoryUploadStates = async ({ request, reason, }) => {
    try {
        const { data, error, response } = await fileRepositoryClient.POST('/rest/file-repository/uploads', reason, {
            headers: {
                'content-type': 'application/json',
            },
            body: request,
            timeoutMs: getQueryTimeoutMs(),
            numRetries: 1,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data ?? null;
    }
    catch (err) {
        logger.error(err);
        return null;
    }
};
//# sourceMappingURL=getRepositoryUploadStates.js.map